import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  FieldDefinitionType,
  PanelDefinition,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

@Component({
  selector: 'atx-indicators-panel',
  templateUrl: './indicators-panel.component.html',
  styleUrls: ['./indicators-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IndicatorsPanelComponent {
  public readonly textType = FieldDefinitionType.text;
  public readonly badgeType = FieldDefinitionType.badge;
  public readonly customIconType = FieldDefinitionType.customIcon;

  @Input() public customIconsPath: string;

  @Input()
  public componentDef: PanelDefinition;

  public getIconClass(color?: string) {
    return `text-${color ?? 'dark'}`;
  }
}
